import { TypeNames, type IDisplayEntity, type IPropertyScopedStorable } from '../shared/storable';

export const PropertyMemberRole = {
  Owner: 'owner',
  Manager: 'manager',
  Member: 'member',
  Viewer: 'viewer',
  Inactive: 'inactive',
} as const;

export type PropertyMemberRole = (typeof PropertyMemberRole)[keyof typeof PropertyMemberRole];

export const PropertyMemberStatus = {
  Active: 'active',
  Invited: 'invited',
  Removed: 'removed',
} as const;

export type PropertyMemberStatus = (typeof PropertyMemberStatus)[keyof typeof PropertyMemberStatus];

export type PropertyMemberType = 'USER' | 'ORGANIZATION' | 'homeowner' | 'user' | 'organization' | 'org';

export interface IPropertyMember extends IPropertyScopedStorable, IDisplayEntity {
  typeName: typeof TypeNames.PropertyMember;
  userID?: string;
  orgID?: string;
  organizationID?: string;
  memberID?: string;
  memberType?: PropertyMemberType;
  profileType?: 'homeowner' | 'business';
  role: PropertyMemberRole;
  status: PropertyMemberStatus;
}
